var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.value
        ? _c("ModalFullScreen", {
            attrs: { size: "xl", title: "Invite Resources" },
            on: { close: _vm.handleCancel },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "ModalTabs",
                        {
                          attrs: { tabs: _vm.tabs },
                          on: { tabIndexUpdated: _vm.updateTabIndex },
                        },
                        [
                          _vm.selectedTabIndex === 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "pt-2 border-t-2 border-transparent",
                                },
                                [
                                  _c("ValidationObserver", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ invalid, dirty }) {
                                            return [
                                              _c(
                                                "form",
                                                {
                                                  on: {
                                                    submit: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.invite()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "ModalContent",
                                                    {
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "actions",
                                                            fn: function () {
                                                              return [
                                                                _c("UiButton", {
                                                                  staticClass:
                                                                    "mr-3",
                                                                  attrs: {
                                                                    variant:
                                                                      "outline",
                                                                    id: "cancelInviteContractor",
                                                                    buttonClasses:
                                                                      "px-14",
                                                                    buttonText:
                                                                      "Cancel",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.handleCancel,
                                                                  },
                                                                }),
                                                                _c("UiButton", {
                                                                  attrs: {
                                                                    type: "submit",
                                                                    buttonClasses:
                                                                      "px-15",
                                                                    id: "inviteContractorButton",
                                                                    disabled:
                                                                      _vm.loading ||
                                                                      invalid ||
                                                                      !dirty,
                                                                    buttonText:
                                                                      _vm.loading
                                                                        ? "Loading..."
                                                                        : "Invite",
                                                                  },
                                                                }),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.users,
                                                        function (item, index) {
                                                          return _c(
                                                            "UserInvitationData",
                                                            {
                                                              key: index,
                                                              attrs: {
                                                                userEmail:
                                                                  item.email,
                                                                userGivenName:
                                                                  item.givenName,
                                                                userFamilyName:
                                                                  item.familyName,
                                                                userId: item.id,
                                                                processing:
                                                                  item.processing,
                                                                companyId:
                                                                  _vm.companyId,
                                                                index: index,
                                                                userSource:
                                                                  _vm.users,
                                                                usersToCheck:
                                                                  _vm.invitationTabUsers,
                                                                allowDelete:
                                                                  _vm.allowDelete,
                                                                is_public:
                                                                  item.is_public,
                                                              },
                                                              on: {
                                                                "update:userEmail":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "email",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:user-email":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "email",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:userGivenName":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "givenName",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:user-given-name":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "givenName",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:userFamilyName":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "familyName",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:user-family-name":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "familyName",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:userId":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "id",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:user-id":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "id",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:processing":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "processing",
                                                                      $event
                                                                    )
                                                                  },
                                                                "update:is_public":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      item,
                                                                      "is_public",
                                                                      $event
                                                                    )
                                                                  },
                                                                delete:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleDeleteRow(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex justify-end",
                                                        },
                                                        [
                                                          _c("UiButton", {
                                                            attrs: {
                                                              id: "addNewManagerid",
                                                              variant:
                                                                "primary",
                                                              buttonText: "Add",
                                                            },
                                                            on: {
                                                              click: _vm.add,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "icon",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "PlusIcon",
                                                                        {
                                                                          staticClass:
                                                                            "w-2.5 h-2.5",
                                                                        }
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      668285875
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.selectedTabIndex === 1
                            ? _c("CsvUploader", {
                                attrs: {
                                  companyId: _vm.companyId,
                                  csvUploadCompleted: _vm.csvUploadCompleted,
                                  loadingFinished: _vm.uploading,
                                  usersUnlimited: "",
                                },
                                on: {
                                  csvUploadUsers: _vm.invite,
                                  close: function ($event) {
                                    return _vm.$emit("input", false)
                                  },
                                  clearCsv: _vm.clearCsv,
                                  wrongExtension: _vm.extensionAlert,
                                  invalidHeaderRow: _vm.invalidHeaderRow,
                                },
                                model: {
                                  value: _vm.csvParseOutput,
                                  callback: function ($$v) {
                                    _vm.csvParseOutput = $$v
                                  },
                                  expression: "csvParseOutput",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              533587948
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }